
import { computed, defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'CustomStat',
  props: {
    label: {
      type: String,
      required: true
    }
  },
  setup (props) {
    return {
      label: props.label
    }
  }
});
